import { AppIcon } from 'modules/mobileApps/components/AppIcon';
import { MobileApp } from 'modules/mobileApps/types';
import {
  CheckboxLabel,
  IndentedPaddedFormSectionContent,
  SelectHelper,
  SelectLink,
  TallRowWrapper,
} from 'modules/workflowNodeEditors/EditorBody.styled';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { StyledLabel } from './SelectiveTargeting.styled';

type Props = {
  mobileApps: MobileApp[];
  mobileAppIds: number[];
  setMobileAppIds: (apps: number[]) => void;
  isDisabled?: boolean;
};

export const CustomAppsList = ({
  mobileApps,
  mobileAppIds,
  setMobileAppIds,
  isDisabled = false,
}: Props) => {
  const onClickApp = (app: MobileApp) => {
    const removingAppFromList = mobileAppIds.includes(app.id);
    const newMobileAppIds = removingAppFromList
      ? mobileAppIds.filter((id) => id !== app.id)
      : [...mobileAppIds, app.id];
    setMobileAppIds(newMobileAppIds);
  };

  const onClickSelectNone = () => setMobileAppIds([]);
  const onClickSelectAll = () => setMobileAppIds(mobileApps.map((app) => app.id));

  return (
    <IndentedPaddedFormSectionContent>
      {mobileApps.map((app) => (
        <TallRowWrapper key={app.id}>
          <Checkbox
            key={app.id}
            id={`app-${app.id}-checkbox`}
            status={
              mobileAppIds.includes(app.id) ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED
            }
            labelId="selective-in-app-checkbox-label"
            onClick={() => onClickApp(app)}
            isDisabled={isDisabled}
          />
          <CheckboxLabel
            id={`app-${app.id}-label`}
            htmlFor="selective-in-app"
            onClick={() => onClickApp(app)}
          >
            <AppIcon platformType={app.platform} width={16} />
            <StyledLabel htmlFor={`app-${app.id}-checkbox`}>{app.name}</StyledLabel>
          </CheckboxLabel>
        </TallRowWrapper>
      ))}
      {!isDisabled && (
        <SelectHelper>
          <SelectLink onClick={onClickSelectAll}>Select all</SelectLink>
          <span> | </span>
          <SelectLink onClick={onClickSelectNone}>Select none</SelectLink>
        </SelectHelper>
      )}
    </IndentedPaddedFormSectionContent>
  );
};
